<template>
  <span class="date-picker">
    <v-menu
      v-model="menu"
      :close-on-content-click="true"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="formatted"
          :label="title"
          append-icon="calendar_today"
          readonly
          v-bind="attrs"
          v-on="on"/>
      </template>
      <v-date-picker @change="dateChanged"
                     v-model="date"
                     :landscape="true"
                     :allowed-dates="isDateAllowed || allowAll"
                     input="menu = false">
      </v-date-picker>
    </v-menu>
  </span>
</template>

<script>
import moment from 'moment';
import { formatMonthDate } from '@/services/dates';

export default {
  name: 'DatePicker',
  props: {
    inputDate: String,
    title: String,
    isDateAllowed: Function,
  },
  data() {
    return {
      menu: false,
      date: this.inputDate,
    };
  },
  computed: {
    formatted() {
      return `${formatMonthDate(this.inputDate)}, ${moment(this.inputDate).year()}`;
    },
  },
  watch: {
    inputDate: {
      handler() {
        this.date = this.inputDate;
      },
    },
  },
  methods: {
    dateChanged() {
      this.$emit('changed', this.date);
    },
    allowAll() {
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

::v-deep.date-picker {
  .v-input__slot {
    box-sizing: border-box;
    border: $border-width-thin solid var(--border-primary);
    border-radius: $radius-sm;
    background-color: var(--bg-primary);

    .v-icon {
      font-size: $font-size-md;
    }

    .v-text-field__slot {
      padding-left: $space-3;

      .v-label {
        top: 0;
      }
    }
  }
}

::v-deep .v-text-field__slot .v-label--active {
  text-transform: uppercase;
  font-size: $font-size-xs;
}

::v-deep .theme--light.v-input input, .theme--light.v-input textarea {
  font-size: $font-size-base;
}
</style>
